import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class SeoService {
    constructor(@Inject(DOCUMENT) private doc: Document) { }

    setJsonLd(data: any) {
        let script = this.doc.getElementById('json-ld-script') as HTMLScriptElement;

        if (!script) {
            script = this.doc.createElement('script');
            script.id = 'json-ld-script';
            script.type = 'application/ld+json';
            this.doc.head.appendChild(script);
        }

        script.text = JSON.stringify(data);
    }
}
